import { ShiftTypeEnum } from '@umss/shared/utils';
import { ShiftNeed } from '../models/shift-need.model';

/**
 * Resolves the bonus amount for a shift need.
 *
 * The bonus is the extra amount the facility added on top of their configured
 * base rate when creating the shift.
 *
 * The backend now provides `bonus` directly on `ShiftNeedDto`. Falls back to
 * the legacy calculation for responses that pre-date the rate model rework.
 *
 * Returns null when no bonus is present.
 */
export function resolveShiftBonus(shiftNeed: ShiftNeed): number | null {
  // Prefer the direct field from the new API
  if (shiftNeed.bonus != null && shiftNeed.bonus > 0) {
    return shiftNeed.bonus;
  }

  // Legacy fallback: derive from rateInfo if available
  const { hourlyRate, shiftType, rateInfo } = shiftNeed;

  if (!rateInfo) return null;

  const isUrgent = shiftType === ShiftTypeEnum.Urgent;
  const configuredRate = isUrgent
    ? rateInfo.facilityUrgentHourlyRate
    : rateInfo.facilityNormalHourlyRate;

  if (configuredRate == null) return null;

  const bonus = Number(hourlyRate) - Number(configuredRate);
  return bonus > 0 ? bonus : null;
}
